import { Button } from "@/components/ui/button";
import { WavyBackground } from "@/components/ui/wavy-background";
import { useConnectUser } from "@/hooks/use-connect-user";
import { ArrowDown } from "lucide-react";
import { useRouter } from "next/navigation";

type ScrollDownActionType =
    | "split-payments"
    | "co-ownership-campaigns"
    | "content-marketplace"
    | "blockchain-payouts"
    | "start-exploring";

export function HeroSectionV2({ onScrollDownAction }: { onScrollDownAction: (type: ScrollDownActionType) => void }) {
    const { connect } = useConnectUser();
    const router = useRouter();

    return (
        <>
            <WavyBackground className="relative mx-auto">
                <div className="mx-4 flex flex-col items-center">
                    <div className="max-w-2xl text-balance text-center font-bold text-4xl text-white leading-tight md:text-5xl">
                        The YouTube & TikTok <span className="text-accent-flashy">Payout Alternative</span>
                    </div>
                    <div className="mt-3 max-w-md text-balance text-center text-muted-foreground ">
                        World's First Yield-Generation Program for YouTube, Realtime Payouts, and the Lowest Fees in the
                        Industry.
                    </div>

                    <div className="mt-6 flex flex-wrap justify-center gap-2 text-xs">
                        <Button
                            onClick={() => {
                                if (connect("signup") === "already-connected") {
                                    router.push("/dashboard");
                                }
                            }}
                            variant="default"
                        >
                            Get Started
                        </Button>
                    </div>
                </div>
            </WavyBackground>
            <div className="absolute right-0 bottom-0 left-0 mb-4 flex flex-col items-center">
                <Button
                    className="animate-bounce rounded-full"
                    size="icon"
                    onClick={() => {
                        onScrollDownAction("start-exploring");
                    }}
                    variant="outline"
                >
                    <ArrowDown />
                </Button>
                <p className="mt-2 font-bold text-muted-foreground text-sm uppercase">Start Exploring</p>
            </div>
        </>
    );
}
